import { makeStyles } from '@mui/styles';
import { DocumentTag_FieldsFragment } from 'queries';

const useStyles = makeStyles(() => ({
  pillContainer: {
    padding: '4px 8px',
    borderRadius: '10px',
    fontSize: '12px',
  },
}));

type Props = {
  documentTag?: DocumentTag_FieldsFragment | null;
};

const DocumentTagPill = ({ documentTag }: Props) => {
  const classes = useStyles();
  if (!documentTag) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: documentTag.pillBackgroundColor,
        color: documentTag.pillTextColor,
      }}
      className={classes.pillContainer}
    >
      {documentTag.name}
    </div>
  );
};

export default DocumentTagPill;
